export default __webpack_public_path__ + "static/media/instrucciones-6.93bd8ae1.jpg";